import React from 'react';
import logos from 'ui/assets/logos.png';

const SplashScreen = ({ style }) => {
  return (
    <div className="h-100 w-100 bg-white d-flex align-items-center justify-content-center fullscreen">
      <div className="d-flex flex-row position-relative mt-n5 ms-5 ms-md-0">
        <p className="text-load fw-semibold fs-5">Loading</p>
        <div className="respon-loader">
          <div className="square">
            <img src={logos} alt="" />
          </div>
          <div className="path">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
